import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Agreement } from '@tdwb/lazy/platform/preferences';

@Component({
  selector: 'td-wb-consolidated-exchange-agreements-modal',
  templateUrl: 'consolidated-agreements.modal.component.html',
  styleUrls: ['consolidated-agreements.modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ConsolidatedAgreementsModalComponent {
  @Input() agreement: Agreement;

  isDisabled(): boolean {
    return this.agreement.agreementStatus === 'ACCEPTED';
  }
}
